import React from 'react'
export default function Progess({index,numQuestions,points,maxPossiblePoits,answer}) {
  return (
    <header className='progress'>
        <progress max={numQuestions} value={index + Number(answer !== null)} />
<p>
    Question <strong>{index+1}</strong>/
    {numQuestions}
</p>
<p>
  <strong>{points}</strong>/{maxPossiblePoits}
</p>
    </header>
  )
}
